import { ShieldCheck } from "lucide-react";

/* Small inline checklist of password rules, mirrors backend
 * validate_password_strength() in server.py. */
export default function PasswordRulesHint() {
  return (
    <div className="rounded-md border border-slate-200 bg-slate-50 p-3 text-xs text-slate-700" data-testid="password-rules-hint">
      <div className="mb-1 flex items-center gap-1.5 font-semibold text-slate-900">
        <ShieldCheck className="size-3.5 text-teal-700" /> Password rules
      </div>
      <ul className="list-disc pl-5">
        <li>At least 8 characters</li>
        <li>Contains at least one letter and one digit</li>
        <li>No leading or trailing spaces</li>
        <li>Different from your current password</li>
      </ul>
    </div>
  );
}
